import { ContentTypeEnum, Router as BaseRouter } from 'lingo2-models';
import { EFilterList, ILibraryFilter } from './widget-filter.types';

/* Типы контента, которые не надо отображать в фильтре */
const notFilteringContentTypes: ContentTypeEnum[] | number[] = [
  1, // ContentTypeEnum.lesson
  4, // ContentTypeEnum.test
  10, // ContentTypeEnum.document
  12, // ContentTypeEnum.mix
  13, // ContentTypeEnum.memorizer
  17, // ContentTypeEnum.microtext
];

/* Типы контента для отображения в фильтре */
export const filteringContentTypes: ContentTypeEnum[] = Object.keys(BaseRouter.contentTypeUrlMap)
  .map((contentType) => +contentType)
  .filter((contentType: ContentTypeEnum) => !notFilteringContentTypes.includes(+contentType));

export const filterList: ILibraryFilter[] = [
  {
    name: EFilterList.subject,
    label: 'library.filter-widget.subject', // дисциплины
    placeholder: 'library.filter-widget.placeholders.subject',
    children: [
      {
        name: 'foreign',
        label: 'library.filter-widget.foreign',
        type: 'subjects',
        options: [],
        property: {
          title: 'title',
          value: 'id',
        },
      },
      {
        name: 'native',
        label: 'library.filter-widget.native',
        type: 'subjects',
        options: [],
        property: {
          title: 'title',
          value: 'id',
        },
      },
      {
        name: 'non_categorized',
        label: 'library.filter-widget.non_categorized',
        type: 'subjects',
        options: [],
        property: {
          title: 'title',
          value: 'id',
        },
      },
    ],
    type: 'subjects',
    property: {
      title: 'title',
      value: 'id',
    },
    selected: [],
    display: true,
  },
  {
    name: EFilterList.contentType,
    label: 'library.filter-widget.category', // Категории
    placeholder: 'library.filter-widget.placeholders.category',
    type: 'checkbox',
    property: {
      title: 'title',
      value: 'id',
    },
    options: [],
    selected: [],
    display: true,
  },
  {
    name: EFilterList.level,
    label: 'library.filter-widget.level', // Уровень
    placeholder: 'library.filter-widget.placeholders.level',
    type: 'checkbox',
    property: {
      title: 'title',
      value: 'id',
    },
    options: [],
    selected: [],
    display: false,
  },
  {
    name: EFilterList.order,
    label: 'library.filter-widget.popularity', // Популярность
    type: 'radio',
    property: {
      title: 'title',
      value: 'id',
    },
    options: [],
    selected: [],
    display: true,
  },
  {
    name: EFilterList.language,
    label: 'library.filter-widget.language', // Язык контента
    placeholder: 'library.filter-widget.placeholders.language',
    type: 'checkbox',
    property: {
      title: 'title',
      value: 'id',
    },
    options: [],
    selected: [],
    display: true,
  },
];
